import { render, staticRenderFns } from "./BagkurAktifDetay.vue?vue&type=template&id=389b9e28&scoped=true"
import script from "./BagkurAktifDetay.vue?vue&type=script&lang=ts"
export * from "./BagkurAktifDetay.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389b9e28",
  null
  
)

export default component.exports